import { PlaceholderShape } from '@/features/shared/placeholder/PlaceholderShape';
import { makeStyles } from '@material-ui/core/styles';
import { range } from 'lodash/fp';
import React from 'react';

const useSDLTablePlaceholderStyles = makeStyles({
  root: {
    '& .fake-result-row': {
      height: '50px',
      marginBottom: '10px',
    },
    '& .fake-result-row:last-child': {
      marginBottom: '0',
    },
    '& .fake-table-content': {
      padding: '30px',
    },
    '& .fake-filter-header': {
      height: '80px',
    },
  },
});

export const SDLTablePlaceholder = ({ theme }: PropsWithTheme<any>) => {
  const classes = useSDLTablePlaceholderStyles();

  return (
    <div className={classes.root}>
      <PlaceholderShape theme={theme} level="0">
        <PlaceholderShape theme={theme} level="4" className="fake-filter-header" />
        <div className="fake-table-content">
          {range(0, 6).map((key) => (
            <PlaceholderShape
              key={key}
              theme={theme}
              rounded
              className="fake-result-row"
              level="2"
            />
          ))}
        </div>
      </PlaceholderShape>
    </div>
  );
};
